import './FiSelectPanelMaterialDialog.scss';

import * as angular from 'angular';

import { Component } from '../Component';
import { FiFurnitureService, iMDFItem } from '../fiFurniture/FiFurnitureService';

@Component({
    controllerAs: 'vm',
    template: require('./FiSelectPanelMaterialDialog.html'),
    bindings: {
        hideButton: '<' 
    },
})
export class FiSelectPanelMaterialDialog {
    static $inject = [
        '$mdDialog',
        'fiFurnitureService',
        '$http',
    ];

    constructor(
        private $mdDialog: angular.material.IDialogService,
        private fs: FiFurnitureService,
        private $http: angular.IHttpService,
    ) {
        //
    }

    lmdp_items = [];
    lmdp_results = [];

    mdf_items = [];
    mdf_results = [];

    filter = {
        lmdp: {
            color_tone: 0,
            color: 0,
            gloss: 0,
            roughness: 0,
            pattern: 0,
            manufacturer: 0,
            supplier: 0
        },
        mdf: {
            plate_thickness: 0,
            gloss: 0
        }
    };

    $onInit() {

        // LMDP
        this.$http.get('https://www.fitit.lt/db/lmdp.php').then((data) => {
            this.lmdp_items.push(data.data);
            this.lmdp_results = this.lmdp_items[0];
        });

        // MDF
        this.$http.get('https://www.fitit.lt/db/mdf.php').then((data) => {
            this.mdf_items.push(data.data);
            this.mdf_results = this.mdf_items[0];
        });

        this.fs.furniture.activeRow.mdf_thickness = 0;
        this.fs.selected_mdf_gloss = this.fs.furniture.activeRow.mdf_gloss;
    }

    selectMaterialType(type: boolean) {
        this.fs.furniture.activeRow.is_mdf = type;
    }

    applyFilter(filterCategory: number) {


        this.lmdp_results = this.lmdp_items[0];

        if (this.filter.lmdp.color_tone) {
            this.lmdp_results = this.lmdp_results.filter(item => item.color_tone == this.filter.lmdp.color_tone );
        }
        
        if (this.filter.lmdp.color) {
            this.lmdp_results = this.lmdp_results.filter(item => item.color == this.filter.lmdp.color );
        }

        if (this.filter.lmdp.gloss) {
            this.lmdp_results = this.lmdp_results.filter(item => item.gloss == this.filter.lmdp.gloss );
        }
        
        if (this.filter.lmdp.roughness) {
            this.lmdp_results = this.lmdp_results.filter(item => item.roughness == this.filter.lmdp.roughness );
        }

        if (this.filter.lmdp.pattern) {
            this.lmdp_results = this.lmdp_results.filter(item => item.pattern == this.filter.lmdp.pattern );
        }
        
        if (this.filter.lmdp.supplier) {
            this.lmdp_results = this.lmdp_results.filter(item => item.supplier == this.filter.lmdp.supplier );
        }
      
    }

    applyMDFFilter() {
        if (this.fs.sameDoorsPanel) {
            for(const column of this.fs.furniture.columns) {

                for(const row of column.rows) {
                    row.mdf_gloss = this.fs.selected_mdf_gloss;
                    //row.mdf_thickness = this.fs.furniture.activeRow.mdf_thickness;
                }
            }
        }
        else {
            this.fs.furniture.activeRow.mdf_gloss = this.fs.selected_mdf_gloss;
        }
    }

    getMDFPanelPrice(mdf: iMDFItem) {

        if (this.fs.selected_mdf_gloss == 0) {
            if (this.fs.furniture.activeRow.mdf_thickness == 0) {
                return mdf.price_matte_2_side;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 1) {
                return Number(mdf.price_matte_2_side) + 4;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 2) {
                return Number(mdf.price_matte_2_side) + 5.57;
            }
        }
        else if (this.fs.selected_mdf_gloss == 1) {
            if (this.fs.furniture.activeRow.mdf_thickness == 0) {
                return mdf.price_matte_1_side;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 1) {
                return Number(mdf.price_matte_1_side) + 4;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 2) {
                return Number(mdf.price_matte_1_side) + 5.57;
            }
        }
        else if (this.fs.selected_mdf_gloss == 2) {
            if (this.fs.furniture.activeRow.mdf_thickness == 0) {
                return mdf.price_shiny_1_side;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 1) {
                return Number(mdf.price_shiny_1_side) + 4;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 2) {
                return Number(mdf.price_shiny_1_side) + 5.57;
            }
        }
        else if (this.fs.selected_mdf_gloss == 3) {
            if (this.fs.furniture.activeRow.mdf_thickness == 0) {
                return mdf.price_super_shiny_1_side;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 1) {
                return Number(mdf.price_super_shiny_1_side) + 4;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 2) {
                return Number(mdf.price_super_shiny_1_side) + 5.57;
            }
        }
        else if (this.fs.furniture.activeRow.mdf_gloss == 4) {
            if (this.fs.furniture.activeRow.mdf_thickness == 0) {
                return mdf.price_super_shiny_2_side;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 1) {
                return Number(mdf.price_super_shiny_2_side) + 4;
            }
            else if (this.fs.furniture.activeRow.mdf_thickness == 2) {
                return Number(mdf.price_super_shiny_2_side) + 5.57;
            }
            
            
        }
    }

   
    close() {
        this.$mdDialog.cancel();
    }

}